export const colors = {
  primary: {
    main: '#0047BB',
    hover: '#003BA0',
    light: '#336ED9',
    dark: '#002E75',
  },
  secondary: {
    main: '#A0AFC0',
    light: '#D0DAE5',
    dark: '#70849B',
  },
  background: {
    paper: '#f9f9fb',
    default: '#f5f5f5',
    sidebarGlass: '#FFFFFF',
    inactive: '#f5f5f5',
    warning: '#fffde7',
  },
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#999999',
    white: '#FEFEFE',
    muted: '#555555',
  },
  switch: {
    track: '#cccccc',
    checked: '#003BA0',
    
    // Duplicate toggle switch colors
    duplicateThumb: 'orange',     // Orange thumb for duplicate switch
    duplicateThumbDisabled: 'white', // White thumb when disabled
  },
  button: {
    disabled: '#A0AFC0',
  },
  brand: {
    purple: '#6D2A5B',
  },
  
  // Status colors
  status: {
    success: '#4CAF50',
    warning: '#FF9800',
    error: '#F44336',
    info: '#2196F3',
  },

  // Warning/Alert colors (for duplicates, etc.)
  alert: {
    border: '#fbc02d',        // Yellow border for warning panels
    backgroundHigh: '#FFEB3B', // Bright yellow for high priority
    backgroundMedium: '#FFF9C4', // Light yellow for medium priority
  },
  
  // Common grays
  gray: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // Interaction colors
  interaction: {
    hover: 'rgba(0,0,0,0.04)', // Light hover state for menu items
  },

  // MUI-compatible theme colors for consistent usage
  mui: {
    success: 'success.main',  // Green for positive actions
    error: 'error.main',      // Red for negative actions  
    warning: 'warning.main',  // Orange/amber for neutral/unknown
    inactive: 'grey.400',     // Gray for inactive states
  },
} as const;